import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { dump } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { RoleRouteObject, RouteFunctionParams } from '@/types'
import { defer, ActionFunction, LoaderFunction } from 'react-router-typesafe'
import { Roles } from '@/auth/azure/Roles'
import DumpEditor from '@/routes/dumps/DumpEditor'
import { StatoDump } from '@/routes/dumps/Dump.enums'
import { getAzureUserInformation } from '@/auth/azure/azureManager'

export const dumpEditorRouteLoader = (async ({ request, params }: RouteFunctionParams<'dumpId' | 'clientId'>) => {
  const dumpId = params.dumpId
  const clientId = params.clientId

  const qsAdminApi = useQsAdminApiManager.getState().service

  const dump = await qsAdminApi.dump(Number(dumpId)).query((builder, dump) => {
    builder.expanding('email', (emailBuilder, email) => {
      emailBuilder.select('id', 'email')
    })
    builder.expanding('licenza', (licenzaBuilder, licenza) => {
      licenzaBuilder.expanding('sede', (sedeBuilder, sede) => {
        sedeBuilder.expanding('azienda', (aziendaBuilder, azienda) => {
          aziendaBuilder.select('id', 'nome')
        })
        sedeBuilder.select('id', 'nome', 'azienda')
      })
      licenzaBuilder.select('id', 'chiave', 'sede')
    })
    builder.expanding('stato', (statoBuilder, stato) => {
      statoBuilder.select('id', 'nome')
    })
    builder.expanding('tipologie', (tipologieBuilder, tipologia) => {
      tipologieBuilder.select('id', 'nome')
    })
  })
  let title = clientId ? `${dump.data.licenza?.sede?.azienda?.nome} - ` : ``
  title += dump.data.ded_Dis

  const getStati = qsAdminApi.stato_dump().query((builder, stato) => {
    if (dump.data.stato?.id === StatoDump.VISIONATO) builder.filter(stato.id.ne(StatoDump.NUOVO))
    if (dump.data.stato?.id === StatoDump.ANALIZZATO)
      builder.filter(stato.id.ne(StatoDump.NUOVO).and(stato.id.ne(StatoDump.VISIONATO)))
    builder.select('id', 'nome')
    builder.orderBy(stato.id.asc())
  })

  const getTipologie = qsAdminApi.tipologia_dump().query((builder, tipologia) => {
    builder.select('id', 'nome')
    builder.orderBy(tipologia.nome.asc())
  })

  return defer({
    title,
    dump,
    getStati,
    getTipologie,
    getUserInfo: getAzureUserInformation(),
    defaultCRUDAllowedRoles: [Roles.GlobalAdministrator, Roles.TechDeveloper],
  })
}) satisfies LoaderFunction

export const dumpEditorRouteAction = (async ({ request }: RouteFunctionParams) => {
  const dump = (await request.json()) as dump
  console.log('hour', dump)
  const qsAdminApi = useQsAdminApiManager.getState().service

  switch (request.method) {
    case 'PUT':
    case 'PATCH': {
      return await qsAdminApi.dump(dump.id).update(dump)
    }
    default: {
      throw new Response('Method not allowed', {
        status: 405,
        statusText: 'Method not allowed',
      })
    }
  }
}) satisfies ActionFunction

const DumpEditorRoute = {
  path: ':dumpId',
  element: <DumpEditor creating={false} />,
  loader: dumpEditorRouteLoader,
  action: dumpEditorRouteAction,
  allowedRoles: [Roles.GlobalAdministrator, Roles.TechDeveloper],
  handle: {
    crumb: (match) => ({
      label: match.data.dump.data.ded_Dis,
    }),
  },
} as RoleRouteObject

export default DumpEditorRoute
